export const RARITIES = {
    COMMON: { id: 'common', name: 'Common', color: '#94a3b8', probability: 0.50, value: 1, glow: '0 0 10px rgba(148, 163, 184, 0.5)' }, 
    RARE: { id: 'rare', name: 'Rare', color: '#3b82f6', probability: 0.30, value: 2, glow: '0 0 20px rgba(59, 130, 246, 0.6)' },   
    EPIC: { id: 'epic', name: 'Epic', color: '#a855f7', probability: 0.15, value: 3, glow: '0 0 30px rgba(168, 85, 247, 0.7)' },   
    LEGENDARY: { id: 'legendary', name: 'Legendary', color: '#eab308', probability: 0.05, value: 4, glow: '0 0 40px rgba(234, 179, 8, 0.8)' }, 
};

// 7-Day Streak Rewards
export const DAILY_REWARDS = [
    100,  // Day 1
    200,  // Day 2
    350,  // Day 3
    500,  // Day 4
    750,  // Day 5
    1000, // Day 6
    2500  // Day 7 (Jackpot)
];

// NEW: Coin Packs Configuration
export const COIN_PACKS = [
    { 
        id: 'coins_500', 
        name: 'Small Coin Pack', 
        amount: 500, 
        price: 0.99, 
        priceLabel: '$0.99', 
        iconScale: 1 
    },
    { 
        id: 'coins_2800', 
        name: 'Medium Coin Pack', 
        amount: 2800, 
        price: 4.99, 
        priceLabel: '$4.99', 
        tag: 'MOST POPULAR', 
        iconScale: 1.2 
    },
    { 
        id: 'coins_6500', 
        name: 'Large Coin Pack', 
        amount: 6500, 
        price: 9.99, 
        priceLabel: '$9.99', 
        tag: 'BEST VALUE', 
        tagColor: 'var(--c-purple)', 
        iconScale: 1.3 
    },
    { 
        id: 'coins_15000', 
        name: 'Mega Coin Pack', 
        amount: 15000, 
        price: 19.99, 
        priceLabel: '$19.99', 
        iconScale: 1.4 
    }
];

export const SKINS = [
    // --- PLAYER SKINS ---
    { id: 'default', type: 'player', name: 'Default', rarity: 'COMMON', cssClass: 'skin-default', priceReal: 0, description: "The standard issue runner." },
    { id: 'mint', type: 'player', name: 'Mint', rarity: 'COMMON', cssClass: 'skin-mint', priceReal: 0.99, description: "Fresh and clean." },
    { id: 'berry', type: 'player', name: 'Berry', rarity: 'COMMON', cssClass: 'skin-berry', priceReal: 0.99, description: "Sweet victory." },
    
    { id: 'ice', type: 'player', name: 'Ice', rarity: 'RARE', cssClass: 'skin-ice', priceReal: 2.99, description: "Stay cool under pressure." },
    { id: 'gold', type: 'player', name: 'Gold', rarity: 'RARE', cssClass: 'skin-gold', priceReal: 3.49, description: "Solid 24k plating." },
    { id: 'shadow', type: 'player', name: 'Shadow', rarity: 'RARE', cssClass: 'skin-shadow', priceReal: 2.99, description: "They'll never see you coming." },

    { id: 'magma', type: 'player', name: 'Magma', rarity: 'EPIC', cssClass: 'skin-magma', priceReal: 5.99, description: "Forged in the depths." },
    { id: 'neon', type: 'player', name: 'Neon', rarity: 'EPIC', cssClass: 'skin-neon', priceReal: 6.99, description: "Light up the grid." },

    { id: 'plasma', type: 'player', name: 'Plasma', rarity: 'LEGENDARY', cssClass: 'skin-plasma', priceReal: 14.99, description: "Pure energy containment." },
    { id: 'holographic', type: 'player', name: 'Holo', rarity: 'LEGENDARY', cssClass: 'skin-holographic', priceReal: 15.99, description: "Is it real, or just a glitch?" },
    
    // EXCLUSIVE BUNDLE SKIN - "ECLIPSE"
    { 
        id: 'eclipse', 
        type: 'player', 
        name: 'Eclipse', 
        rarity: 'LEGENDARY', 
        cssClass: 'skin-eclipse', 
        priceReal: 0, 
        description: "The perfect alignment of shadow and gold." 
    },

    // --- TILE SKINS ---
    { id: 'tile_default', type: 'tile', name: 'Classic', rarity: 'COMMON', cssClass: 'tile-skin-default', priceReal: 0, description: "The original grid walls." },
    { id: 'tile_berry', type: 'tile', name: 'Berry Wall', rarity: 'RARE', cssClass: 'tile-skin-berry', priceReal: 0.99, description: "A pop of color." },

    { id: 'tile_ice', type: 'tile', name: 'Ice Wall', rarity: 'EPIC', cssClass: 'tile-skin-ice', priceReal: 2.99, description: "Slippery surfaces." },
];

export const CASES = [
    {
        id: 'starter_case',
        name: 'Starter Case',
        price: 100,
        image: '📦',
        description: 'Perfect for new recruits.',
        contents: ['mint', 'berry', 'tile_berry', 'ice', 'gold'] 
    },
    {
        id: 'elite_case',
        name: 'Elite Case',
        price: 1000,
        image: '💼',
        description: 'For the serious collector.',
        contents: ['gold', 'shadow', 'tile_ice', 'magma'] 
    },
    {
        id: 'cosmic_case',
        name: 'Cosmic Case',
        price: 2500,
        image: '🌌',
        description: 'Contains only the finest loot.',
        contents: ['neon', 'plasma', 'holographic']
    }
];

export const BUNDLES = [
    {
        id: 'starter_bundle',
        title: 'Starter Bundle',
        price: '$2.99',
        valueTag: '500% VALUE', 
        cssClass: 'bundle-starter',
        contents: {
            coins: 3000,
            skins: ['eclipse'],
            noAds: true
        },
        contentDisplay: [
            { type: 'coin', amount: '3,000', label: 'Coins' },
            { type: 'skin', skinId: 'eclipse', label: 'Exclusive' },
            { type: 'feature', icon: 'zap', label: 'No Ads' }
        ]
    }
];

export const getSkin = (id) => SKINS.find(s => s.id === id) || SKINS[0];

export const getCaseOdds = (caseId) => {
    const c = CASES.find(x => x.id === caseId);
    if (!c) return [];
    
    const caseSkins = SKINS.filter(s => c.contents.includes(s.id));
    
    let totalProbability = 0;
    caseSkins.forEach(s => totalProbability += RARITIES[s.rarity].probability);

    return caseSkins.map(s => ({
        ...s,
        percent: ((RARITIES[s.rarity].probability / totalProbability) * 100).toFixed(1)
    })).sort((a,b) => RARITIES[b.rarity].value - RARITIES[a.rarity].value);
};